import { useTranslation } from "react-i18next"
import { AppHeader } from "../components/AppHeader";
import { Button, Typography, Space, InputNumber } from "antd";
import Icon, { PlusOutlined, EditOutlined, CopyOutlined, DeleteOutlined, CodeSandboxOutlined, TrophyOutlined, ShoppingCartOutlined, GiftOutlined, CrownOutlined, FileDoneOutlined, FormatPainterOutlined, AreaChartOutlined, DollarOutlined, HeatMapOutlined, RobotOutlined, SettingOutlined, BorderlessTableOutlined, StarOutlined, LoadingOutlined } from '@ant-design/icons';
import botconfig from "../botconfig";
import { useParams } from "react-router-dom";
import { message, Spin, Table } from 'antd';
import { login, fetchGuild, fetchSettings, fetchGuilds, fetchUser, fetchGuildItems, fetchGuildAchievements, fetchGuildCategories, fetchGuildGifts, fetchGuildPermissions, fetchGuildPromocodes, fetchGuildQuests, fetchGuildJobs, fetchGuildIncomeRoles, fetchGuildStyles, fetchGuildWormholes, fetchGuildAutogenerators, fetchGuildBonusChannels, fetchProfile } from '../api'
import { GuildCardLoader } from "../components/GuildCardLoader";
import { useState, useEffect } from "react";
export function PremiumPage() {
    const { Text, Link, Title, Paragraph } = Typography;
    const { t } = useTranslation()
    const { guildId } = useParams()
    const [messageApi, contextHolder] = message.useMessage()
    const [settings, setSettings] = useState()
    const [profile, setProfile] = useState()
    const [items, setItems] = useState([])
    const [achievements, setAchievements] = useState([])
    const [categories, setCategories] = useState([])
    const [gifts, setGifts] = useState([])
    const [permissions, setPermissions] = useState([])
    const [quests, setQuests] = useState([])
    const [jobs, setJobs] = useState([])
    const [promocodes, setPromocodes] = useState([])
    const [incomeRoles, setIncomeRoles] = useState([])
    const [styles, setStyles] = useState([])
    const [wormholes, setWormholes] = useState([])
    const [autogenerators, setAutogenerators] = useState([])
    const [bonusChannels, setBonusChannels] = useState([])
    const [guild, setGuild] = useState()
    const [loading, setLoading] = useState(true)
    const [errorStatus, setErrorStatus] = useState()
    const [buyCookies, setBuyCookies] = useState(500);
    const [transferCookies, setTransferCookies] = useState(1);
    function errorMessage(error) {
        console.error(error)
        messageApi.open({
            type: 'error',
            content: error.message,
        });
    }
    useEffect(() => {
        async function fetchData() {
            let user
            let localItem = JSON.parse(localStorage.getItem("wetbot"))
            if (!localItem?.token) return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
            if (localItem.token.expires_at <= Date.now()) {
                localStorage.removeItem("wetbot")
                return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
            } else {
                try {
                    user = await fetchUser(localItem.token)
                } catch (err) {
                    localStorage.removeItem("wetbot")
                    return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
                }
            }
            try {
                let responseGuild
                try {
                    responseGuild = await fetchGuild(guildId, localItem.token.access_token).then(response => response.response)
                    setGuild(responseGuild)    
                } catch (err) {
                    if (err.response.status === 404) {
                        return setErrorStatus(404)
                    } else if (err.response.status === 401) {
                        await fetchGuilds(user.id, localItem.token.access_token)
                        responseGuild = await fetchGuild(guildId, localItem.token.access_token).then(response => response.response)
                        setGuild(responseGuild)  
                    } else if (err.response.status === 403) {
                        return setErrorStatus(403)
                    } else {
                        return errorMessage(err)
                    }
                }
                const responseSettings = await fetchSettings(guildId, localItem.token.access_token).then(response => response.response)
                setSettings(responseSettings)
                let responseProfile
                try {
                    responseProfile = await fetchProfile(guildId, user.id, localItem.token.access_token).then(response => response.response)
                    setProfile(responseProfile)
                } catch (err) {
                    if (err.response.status === 404) {
                        return setErrorStatus(404)
                    } else if (err.response.status === 401) {
                        await fetchGuilds(user.id, localItem.token.access_token)
                        responseGuild = await fetchGuild(guildId, localItem.token.access_token).then(response => response.response)
                        setGuild(responseGuild)
                        responseProfile = await fetchProfile(guildId, user.id, localItem.token.access_token).then(response => response.response)
                        setProfile(responseProfile)
                    } else if (err.response.status === 403) {
                        return setErrorStatus(403)
                    } else {
                        return errorMessage(err)
                    }
                }
                const responseItems = await fetchGuildItems(guildId, localItem.token.access_token)
                setItems(responseItems)
                const responseAchievements = await fetchGuildAchievements(guildId, localItem.token.access_token)
                setAchievements(responseAchievements)
                const responseCategories = await fetchGuildCategories(guildId, localItem.token.access_token)
                setCategories(responseCategories)
                const responseGifts = await fetchGuildGifts(guildId, localItem.token.access_token)
                setGifts(responseGifts)
                const responsePermissions = await fetchGuildPermissions(guildId, localItem.token.access_token)
                setPermissions(responsePermissions)
                const responsePromocodes = await fetchGuildPromocodes(guildId, localItem.token.access_token)
                setPromocodes(responsePromocodes)
                const responseQuests = await fetchGuildQuests(guildId, localItem.token.access_token)
                setQuests(responseQuests)
                const responseJobs = await fetchGuildJobs(guildId, localItem.token.access_token)
                setJobs(responseJobs)
                const responseIncomeRoles = await fetchGuildIncomeRoles(guildId, localItem.token.access_token)
                setIncomeRoles(responseIncomeRoles)
                const responseStyles = await fetchGuildStyles(guildId, localItem.token.access_token)
                setStyles(responseStyles)
                const responseWormholes = await fetchGuildWormholes(guildId, localItem.token.access_token)
                setWormholes(responseWormholes)
                const responseAutogenerators = await fetchGuildAutogenerators(guildId, localItem.token.access_token)
                setAutogenerators(responseAutogenerators)
                const responseBonusChannels = await fetchGuildBonusChannels(guildId, localItem.token.access_token)
                setBonusChannels(responseBonusChannels)
            } catch (err) {
                errorMessage(err)
            }
            setLoading(false)
        }
        fetchData()
    }, [])
    if (loading) {
        return (
          <>
            {contextHolder}
            <AppHeader></AppHeader>
            <Spin style={{ width: "100%", height: "100%", position: "absolute", display: "flex", justifyContent: "center", alignItems: "center" }} indicator={<LoadingOutlined style={{ fontSize: 300, color: "var(--cookie-color)" }} spin />} />
          </>
        )
    }
    return (
        <>
            {contextHolder}
            <AppHeader></AppHeader>
            <div style={{ display: "flex", justifyContent: "center", paddingTop: 10, alignItems: "center", paddingRight: 20, paddingLeft: 20 }}>
                <img src={guild.iconURL} alt="" style={{ height: 41, borderRadius: "50%" }}/>
                <span className="font-800" style={{ fontSize: 30, textAlign: "center" }}>{guild.name}</span>
            </div>
            <div className="container">
                <Table
                    pagination={false}
                    size="small"
                    columns={[
                        {
                            title: t("Базовые возможности"),
                            dataIndex: 'base',
                            key: 'base'
                        },
                        {
                            title: t("Премиальные возможности"),
                            dataIndex: 'premium',
                            key: 'premium'
                        },
                    ]} 
                    dataSource={[
                        {
                            key: '1',
                            base: t("Кулдаун команды /fishing: 30 сек."),
                            premium: t("Кулдаун команды /fishing: 0 сек."),
                        },
                        {
                            key: '2',
                            base: t("Кулдаун команды /mining: 30 сек."),
                            premium: t("Кулдаун команды /mining: 0 сек."),
                        },
                        {
                            key: '3',
                            base: t("Кулдаун команды /open: 30 сек."),
                            premium: t(`Кулдаун команды /open: 0 сек.`),
                        },
                        {
                            key: '4',
                            base: `⛔${t("Доступ к команде /market")}`,
                            premium: `✅${t("Доступ к команде /market")}`,
                        },
                        {
                            key: '5',
                            base: `⛔${t("Доступ к команде /manager-giveaways")}`,
                            premium: `✅${t("Доступ к команде /manager-giveaways")}`,
                        },
                        {
                            key: `6`,
                            base: `⛔${t("Доступ к команде /cs2rank")}`,
                            premium: `✅${t("Доступ к команде /cs2rank")}`,
                        },
                        {
                            key: `7`,
                            base: `⛔${t("Доступ к команде /manager-gifts")}`,
                            premium: `✅${t("Доступ к команде /manager-gifts")}`,
                        },
                        {
                            key: `8`,
                            base: `⛔${t("Возможность включить логи сервера")}`,
                            premium: `✅${t("Возможность включить логи сервера")}`,
                        },
                        {
                            key: `9`,
                            base: `⛔${t("Выдача наград за бампы сервера")}`,
                            premium: `✅${t("Выдача наград за бампы сервера")}`,
                        },
                        {
                            key: `10`,
                            base: `⛔${t("Доступ к ежедневным, еженедельным, ежемесячным и ежегодным отчетам о топ участников")}`,
                            premium: `✅${t("Доступ к ежедневным, еженедельным, ежемесячным и ежегодным отчетам о топ участников")}`,
                        },
                        {
                            key: `11`,
                            base: `⛔${t("Возможность поставить и использовать кастомные эмодзи для предметов, достижений и валюты")}`,
                            premium: `✅${t("Возможность поставить и использовать кастомные эмодзи для предметов, достижений и валюты")}`,
                        },
                        {
                            key: `12`,
                            base: `⛔${t("Возможность установить свой фон и цвета для команды /rank")}`,
                            premium: `✅${t("Возможность установить свой фон и цвета для команды /rank")}`,
                        },
                        {
                            key: `13`,
                            base: `⛔${t("Доступ к API")}`,
                            premium: `✅${t("Доступ к API")}`,
                        },
                        {
                            key: `14`,
                            base: `⛔${t("Доступ к команде /work")}`,
                            premium: `✅${t("Доступ к команде /work")}`,
                        },
                        {
                            key: `15`,
                            base: `⛔${t("Доступ к команде /manager-permissions")}`,
                            premium: `✅${t("Доступ к команде /manager-permissions")}`,
                        },
                        {
                            key: `16`,
                            base: `⛔${t("Доступ к команде /custom-role")}`,
                            premium: `✅${t("Доступ к команде /custom-role")}`,
                        },
                        {
                            key: `17`,
                            base: `⛔${t("Доступ к команде /promocode-autogenerators")}`,
                            premium: `✅${t("Доступ к команде /promocode-autogenerators")}`,
                        },
                        {
                            key: `18`,
                            base: `⚠️${t("25 слотов для предметов")}`,
                            premium: `✅${t("1000 слотов для предметов")}`,
                        },
                        {
                            key: `19`,
                            base: `⚠️${t("5 слотов для достижений")}`,
                            premium: `✅${t("1000 слотов для достижений")}`,
                        },
                        {
                            key: `20`,
                            base: `⚠️${t("5 слотов для червоточин")}`,
                            premium: `✅${t("100 слотов для червоточин")}`,
                        },
                        {
                            key: `22`,
                            base: `⚠️${t("5 слотов для множителей каналов")}`,
                            premium: `✅${t("100 слотов для множителей каналов")}`,
                        },
                        {
                            key: `23`,
                            base: `⚠️${t("5 слотов для стилей")}`,
                            premium: `✅${t("25 слотов для стилей")}`,
                        },
                        {
                            key: `24`,
                            base: `⚠️${t("5 слотов для магазинных категорий")}`,
                            premium: `✅${t("25 слотов для магазинных категорий")}`,
                        },
                        {
                            key: `25`,
                            base: `⚠️${t("5 слотов для квестов")}`,
                            premium: `✅${t("1000 слотов для квестов")}`,
                        },
                        {
                            key: `26`,
                            base: `⚠️${t("5 слотов для доходных ролей")}`,
                            premium: `✅${t("100 слотов для доходных ролей")}`,
                        },
                        {
                            key: `27`,
                            base: `⚠️${t("5 слотов для промокодов")}`,
                            premium: `✅${t("1000 слотов для промокодов")}`,
                        },
                    ]} 
                />
                <Space direction="vertical">
                    <Title level={3}>{t("Для покупки печенек, используй команды:")}</Title>
                    <Paragraph copyable={{ text: '/cookies buy boosty' }}>Boosty: /cookies buy boosty</Paragraph>
                    <Paragraph copyable={{ text: '/cookies buy yookassa' }}>Yookassa: /cookies buy yookassa</Paragraph>
                    <Paragraph copyable={{ text: '/cookies buy crypto' }}>{t("Криптовалюта:")} /cookies buy crypto</Paragraph>   
                </Space>
                <Space direction="vertical">
                    <Title level={3}>{t("Для передачи купленных печенек серверу, используй команду:")}</Title>
                    <Paragraph copyable={{ text: '/cookies give' }}>/cookies give</Paragraph> 
                </Space>
                <Space direction="vertical">
                    <Title level={3}>{t("Для покупки премиума, используй команду:")}</Title>
                    <Paragraph copyable={{ text: '/premium' }}>/premium</Paragraph> 
                </Space>
                <div className="container__buttons">
                    <button className='button primary disabled' style={{ padding: "0 3rem" }}>{t("Получить на 1 месяц (🍪100)")}</button>
                    <button className='button primary disabled' style={{ padding: "0 3rem" }}>{t("Получить навсегда (🍪500)")}</button>
                </div>
                <div className="premium_buttons_container">
                    <div>
                        <Title level={2}>{t("Баланс печенек сервера")} 🍪{settings.cookies}</Title>
                        <Space>
                            <InputNumber style={{ height: 56, fontSize: 25, width: 110, textAlignLast: "center" }} min={1} max={Math.floor(profile.cookies)} value={transferCookies} onChange={setTransferCookies}/>
                            <button className='button primary disabled' style={{ padding: "0 3rem" }}>
                                {t("Передать")} 🍪{transferCookies}
                            </button>
                        </Space>    
                    </div>
                    <div>
                        <Title level={2}>{t("Ваш баланс")} 🍪{Math.floor(profile.cookies)}</Title>
                        <Space>
                            <InputNumber style={{ height: 56, fontSize: 25, width: 110, textAlignLast: "center" }} min={50} max={10000} value={buyCookies} onChange={setBuyCookies}/>
                            <button className='button primary disabled' style={{ padding: "0 3rem" }}>
                                {t("Купить")} 🍪{buyCookies} ({buyCookies * 2} {t("РУБ.")})
                            </button>
                        </Space>    
                    </div>    
                </div>
                
            </div>
        </>
    )
}